/**
 * Подключить таблицу стилей в <head> страницы один раз.
 * Нужно для @font-face: внутри shadow root они не работают
 */
export function appendStylesheet(href: string): void {
    const isAppended = Array.from(document.head.querySelectorAll("link")).some(
        (link) => link.rel === "stylesheet" && link.href === href,
    );

    if (isAppended) return;

    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    document.head.append(link);
}
